import { Suspense } from 'react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { persistor, store, history } from '@s20/store';
import '@s20/i18n';
import App from './App';
import { Notification } from './components/NavMenu/Notification';
import { TenantSettingsSync } from './components/tenant/TenantSettingsSync';

// Surface the stack of any uncaught error / promise rejection so async failures
// (the dev error overlay shows only the message). Browsers
// emit a regular console error, but we add the structured stack here so it's
// trivial to copy into a bug report.
window.addEventListener('error', (e) => {
    console.error('[uncaught error]', e.error?.message ?? e.message, {
        filename: e.filename,
        lineno: e.lineno,
        colno: e.colno,
        stack: e.error?.stack,
    });
});
window.addEventListener('unhandledrejection', (e) => {
    console.error('[unhandled rejection]', e.reason?.message ?? e.reason, {
        stack: e.reason?.stack,
    });
});

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

const root = createRoot(rootElement);

root.render(
    <Provider store={store}>
        <PersistGate
            loading={null}
            persistor={persistor}
        >
            <Router
                basename={baseUrl}
                history={history}
            >
                <QueryClientProvider client={queryClient}>
                    <Suspense fallback={null}>
                        <Notification />
                        <TenantSettingsSync />
                        <App />
                    </Suspense>
                </QueryClientProvider>
            </Router>
        </PersistGate>
    </Provider>,
);